//
//
//
//
//
//
//

import createHead from './headList.js';
import viewportMixin from '@/mixins/viewport.mixin';
import filterMixin from '@/mixins/filter';
import { calculateScaledOffset } from '@/utils/scaled';

import PageLayout from '@/components/autoscale/pageLayout.vue';
import SectionTop from '@/pages/webinars/components/sectionTop.vue';
import SectionCards from '@/pages/webinars/components/sectionCards.vue';

export default {
  name: 'EventsList',
  components: { PageLayout, SectionTop, SectionCards },
  mixins: [filterMixin, viewportMixin],
  layout: 'scaled',
  meta: {
    show: ['br', 'mx'],
  },
  middleware: ['eventDirections'],
  data() {
    return {
      filterNamespace: '',
      filterUpdateStateTriggered: false,
    };
  },
  head() {
    const createHeadFunction = createHead.bind(this);
    return createHeadFunction();
  },
  watch: {
    parsedFilter: {
      handler() {
        if (this.filterUpdateStateTriggered) {
          if (process.browser) {
            const ref = document.querySelector('.events-top-filters');
            const scaledOffset = calculateScaledOffset(ref);

            this.$scrollTo('.events-top-filters', 300, {
              offset: scaledOffset,
            });
          }
        }

        this.filterUpdateStateTriggered = true;
      },
    },
  },

  mounted() {
    this.filterNamespace = 'eventList';
  },
};
